import { NgTemplateOutlet } from '@angular/common';
import { Component, HostBinding, Input, OnChanges } from '@angular/core';

import { CricketInningsData, CricketScore, EventModel, EventScoreboard } from '@frontend/sports/betting-offer/feature/model';
import { SitecoreEventDetailsConfig } from '@frontend/sports/common/client-config-data-access';
import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import { ParticipantImageComponent } from '@frontend/sports/participant-image/feature';

import { ScoreboardParticipantComponent } from './scoreboard-participant.component';

@Component({
    selector: 'ms-cricket-scoreboard',
    templateUrl: 'cricket-scoreboard.component.html',
    imports: [NgTemplateOutlet, ParticipantImageComponent, ScoreboardParticipantComponent],
})
export class CricketScoreboardComponent implements OnChanges {
    @Input() event: EventModel;
    @Input() scoreboard: EventScoreboard;
    @Input() isNewEDPScoreboard = false;
    @HostBinding() class = 'cricket-game';

    cricketScore: CricketScore;
    innings: CricketInningsData;
    showParticipantImages: boolean[] = [];
    rotateImage: boolean[] = [];
    participant1ImageLoaded = false;
    participant2ImageLoaded = false;

    constructor(public sitecoreEventDetails: SitecoreEventDetailsConfig) {}

    ngOnChanges(changes: ISimpleChanges<CricketScoreboardComponent>): void {
        if (changes.scoreboard || changes.event) {
            this.cricketScore = this.scoreboard.getScore<CricketScore>()!;
            this.innings = this.cricketScore.superOver || this.cricketScore.secondInnings || this.cricketScore.firstInnings!;
        }
    }
}
